// extracted by mini-css-extract-plugin
export default {"adornment":"clearable-input_adornment__h+FrF"};